<ek-dialog-header>
    <h4 style="color:rgba(11,119,73,1); font-weight:400;">{{('LABELS.ATTENTION' | translate)}}</h4>
</ek-dialog-header>

<ek-dialog-body class="p-4 text-gray-700 flex justify-center items-center text-center h-full w-full overflow-hidden">
    <p>
       {{('LOGOUT.LOGOUT_MESSAGE' | translate) }}
    </p>
</ek-dialog-body>

<ek-dialog-footer>
        <ek-button class="mr-4" (click)="onCancel()" 
        [label]="'LABELS.CANCEL' | translate" 
        [ekStyle]="'outlined'" 
        [severity]="'danger'"></ek-button>
        
        <ek-button (click)="onConfirm()" 
        [label]="'Esci' | translate" 
        [ekStyle]="'filled'"
        [severity]="'danger'"></ek-button>
</ek-dialog-footer>